/* Match Shopify's market money filter, including lei/zł/Ft and symbol position.
   The sample comes from Liquid; quantities and discount arithmetic stay in cents. */
(() => {
  const config=JSON.parse(document.querySelector('[data-en-config]')?.textContent || '{}');
  const sample=new DOMParser().parseFromString(config.moneySample || '', 'text/html').body.textContent;
  const number=sample.match(/\d(?:[\d.,\s\u00a0\u202f]*\d)?/)?.[0];
  if(!number)return;
  const decimal=number.match(/([.,])\d{2}$/)?.[1] || '';
  const integer=decimal ? number.slice(0,-3) : number;
  const group=integer.match(/[^\d]/)?.[0] || '';
  const localDecimal=new Intl.NumberFormat(document.documentElement.lang || 'en').formatToParts(1.5).find(p=>p.type==='decimal')?.value || '.';
  window.EarthleMoney=cents => {
    const value=Number(cents);if(!Number.isFinite(value))return '';
    // Retain exact fractional prices even when whole-unit prices omit decimals.
    const showDecimals=!!decimal || Math.round(Math.abs(value))%100!==0;
    const [whole,fraction]=(Math.abs(value)/100).toFixed(showDecimals?2:0).split('.');
    const grouped=group ? whole.replace(/\B(?=(\d{3})+(?!\d))/g,group) : whole;
    const amount=grouped+(fraction ? (decimal || localDecimal)+fraction : '');
    return (value<0?'-':'')+sample.replace(number,amount);
  };
})();
